namespace GeniuzPOS.Inventory {
    export class IcStockAdjustOutDtColumns {
        static columnsKey = 'Inventory.IcStockAdjustOutDt';
    }
}
